<template>
  <div id="app">
    
    <router-view />
    
  </div>
</template>

<script>
export default {
  name: "App",
  methods: {

  }
};
</script>

<style lang="scss">
@font-face {
	font-family: 'MyFont';
	src: url('./assets/YourFont/ziti.ttf') format('truetype');
}
    *{
        margin: 0;
        padding: 0;
    }
body,#app{
	margin:0px;
	width: 100vw;
	height: 100vh;
	// min-width: 1500px;
	overflow-y: hidden;
	font-size: 0.24rem;
	// font-family: 'MyFont', sans-serif;
}
.flex-center {
	display: flex;
	justify-content: center;
	flex-wrap: wrap;
	flex-direction: row ;
	align-content: center ;
	align-items: center ;
}

.flex-start {
	display: flex;
	justify-content: flex-start;
	flex-wrap: wrap;
	flex-direction: row ;
	align-content: center ;
	align-items: center ; 
}

.flex-end {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	flex-wrap: wrap;
	flex-direction: row ;
}

.flex-colum {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-content: center ;
	align-items: center ; 
}

.flex-colum-start {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
}

.flex-colum-end {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-end;
}

.flex-between {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	flex-direction: row ;
	align-content: center ;
	align-items: center ; 
}

.flex-around {
	display: flex;
	justify-content: space-around;
	align-items: center;
	flex-wrap: wrap;
	flex-direction: row ;
}

</style>
